var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_40774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50006 0.916992C4.89817 0.916992 4.30217 1.03554 3.74609 1.26588C3.19002 1.49621 2.68476 1.83382 2.25915 2.25942C1.39961 3.11896 0.916727 4.28475 0.916727 5.50033C0.912721 6.55868 1.27917 7.58507 1.95256 8.40158L1.03589 9.31824C0.972297 9.3827 0.929215 9.46454 0.912085 9.55345C0.894956 9.64236 0.904545 9.73436 0.939644 9.81783C0.977712 9.90029 1.03943 9.96959 1.11695 10.0169C1.19447 10.0643 1.28431 10.0875 1.37506 10.0837H5.50006C6.71564 10.0837 7.88142 9.60077 8.74097 8.74123C9.60051 7.88169 10.0834 6.7159 10.0834 5.50033C10.0834 4.28475 9.60051 3.11896 8.74097 2.25942C7.88142 1.39988 6.71564 0.916992 5.50006 0.916992ZM5.50006 9.16699H2.47964L2.90589 8.74074C2.99126 8.65487 3.03917 8.5387 3.03917 8.41762C3.03917 8.29653 2.99126 8.18037 2.90589 8.09449C2.30575 7.49501 1.93202 6.70599 1.84838 5.86186C1.76474 5.01772 1.97637 4.1707 2.44721 3.46511C2.91805 2.75951 3.61896 2.23899 4.43055 1.99223C5.24213 1.74547 6.11416 1.78774 6.89808 2.11183C7.68199 2.43592 8.32928 3.02178 8.72968 3.76961C9.13007 4.51743 9.25879 5.38095 9.09391 6.21304C8.92903 7.04512 8.48074 7.7943 7.82543 8.33294C7.17012 8.87157 6.34833 9.16633 5.50006 9.16699Z",
    fill: "#DF6438"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_40774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.00299ddd3f328a3d7f49bc8db80c4432.svg";
export { ForwardRef as ReactComponent };